import { ColumnTypeEnum } from "../../enums/list-layout/column-type-enum";
import { CustomDateDisplayEnum } from "../../enums/list-layout/custom-date-display-enum";

export class ExportColumnDef {
    displayName: string = '';
    property: string = '';
    isVisible: string = 'false';
    isAmountField: boolean = false;
    width?: string;
    order?: number;
    textAlignment?: string;
    calculatedWidth?: number;
    excelWidth?: number;

    type?: ColumnTypeEnum;
    customDateDisplayOptionSelected?: CustomDateDisplayEnum;

    constructor(displayName: string | undefined, property: string | undefined, isVisible: string | undefined, type: ColumnTypeEnum| undefined, customDateDisplayOptionSelected: CustomDateDisplayEnum|undefined) {
        if (displayName) {
            this.displayName = displayName;
        }
         if (property !== undefined) {
            this.property = property.charAt(0).toUpperCase() + property.slice(1); 
        }
        if (isVisible !== undefined) {
            this.isVisible = isVisible;
        }
        if (type !== undefined) {
            this.type = type;
        }
        if (customDateDisplayOptionSelected !== undefined) {
            this.customDateDisplayOptionSelected = customDateDisplayOptionSelected;
        }
    }
}
